<script>
export default {
    name: 'TaxationForm',

    props: {
        company: {
            type: Object,
            required: true
        },
        taxationTypeOptions: {
            type: Array,
            required: true
        },
        vatDateOptions: {
            type: Array,
            required: true
        },
        vatPeriodicityOptions: {
            type: Array,
            required: true
        },
        vatTypeOptions: {
            type: Array,
            required: true
        },
    },

    data() {
        return {
            form: {
                taxation_type: null,
                vat_type: null,
                vat_periodicity: null,
                vat_date: null
            },
            showSavedAlert: false,
            showNotSavedAlert: false,
            vatKey: 'vatKey',
            vatDisabled: false,
            vat_date_options: null,
            vat_periodicity_options: null,
            init: true,
            forbidden: false,
        }
    }
    ,

    computed: {
        vat_periodicity_filtered_options() {
            return null
        }
        ,

        notSavedMessage() {
            return this.forbidden
                ? `Vous ne pouvez pas changer le type d'imposition car une mission ${this.company.taxation_type} est est activée`
                : 'Les modifications ne sont pas enregistrées'
        }
        ,
    }
    ,

    created() {
        this.initForm()
    }
    ,

    methods: {
        showNotSaved() {
            this.showSavedAlert = false
            this.showNotSavedAlert = true
        }
        ,

        showSaved() {
            this.showSavedAlert = true
            this.showNotSavedAlert = false
        }
        ,

        initForm() {
            this.form.taxation_type =
                this.company.taxation_type === null
                    ? 'ND'
                    : this.company.taxation_type
            this.form.vat_type =
                this.company.vat_type === null ? 'ND' : this.company.vat_type
            this.form.vat_date = this.company.vat_date
            this.form.vat_periodicity = this.company.vat_periodicity
            this.vatHandler()
        }
        ,

        vatHandler() {
            switch (this.form.vat_type) {
                case 'NI':
                    this.vat_periodicity_options = this.vatPeriodicityOptions
                    this.vat_date_options = this.vatDateOptions
                    this.form.vat_date = null
                    this.form.vat_periodicity = null
                    this.vatDisabled = true
                    break
                case 'SP':
                    this.vat_periodicity_options = this.vatPeriodicityOptions
                    this.vat_date_options = this.vatDateOptions
                    this.form.vat_date = 15
                    this.form.vat_periodicity = 'A'
                    this.vatDisabled = true
                    break
                case 'ND':
                    this.vat_periodicity_options = this.vatPeriodicityOptions
                    this.vat_date_options = this.vatDateOptions
                    this.form.vat_date = null
                    this.form.vat_periodicity = null
                    this.vatDisabled = true
                    break
                default:
                    this.vat_periodicity_options =
                        this.vatPeriodicityOptions.filter(
                            (item) => item.value !== 'null'
                        )
                    this.vat_date_options = this.vatDateOptions.filter(
                        (item) => item.value > 0
                    )
                    this.form.vat_date =
                        this.company.vat_date === null
                            ? 15
                            : this.company.vat_date
                    this.form.vat_periodicity =
                        this.company.vat_periodicity === null
                            ? 'M'
                            : this.company.vat_periodicity
                    this.vatDisabled = false
                    break
            }
            this.vatKey = Date.now()

            if (this.init) {
                this.init = false
            } else {
                this.showNotSaved()
            }
        }
        ,

        async legalDataSave() {
            try {
                await axios.put(
                    `clients/${this.company.id}/taxation`,
                    this.form
                )
                this.showSaved()
            } catch (error) {
                this.forbidden = error.response.status === 403
                console.log(error)
            }
        }
        ,
    }
    ,
}
</script>
<template>
    <div>
        <b-form-group>
            <label>Type d'imposition</label>
            <b-form-select
                v-model="form.taxation_type"
                :options="taxationTypeOptions"
                :disabled="company.legal_form === 'PP'"
                @change="showNotSaved"
            />
        </b-form-group>

        <div :key="vatKey" class="row">
            <div class="col-4">
                <b-form-group>
                    <label>Régime de TVA</label>
                    <b-form-select
                        v-model="form.vat_type"
                        :options="vatTypeOptions"
                        :disabled="company.legal_form === 'PP'"
                        @input="vatHandler"
                    />
                </b-form-group>
            </div>
            <div class="col-4">
                <b-form-group>
                    <label>Périodicité TVA</label>
                    <b-form-select
                        v-model="form.vat_periodicity"
                        :options="vat_periodicity_options"
                        :disabled="vatDisabled"
                        @change="showNotSaved"
                    />
                </b-form-group>
            </div>
            <div class="col-4">
                <b-form-group>
                    <label>Echéance TVA</label>
                    <b-form-select
                        v-model="form.vat_date"
                        :options="vat_date_options"
                        :disabled="vatDisabled"
                        @change="showNotSaved"
                    />
                </b-form-group>
            </div>
        </div>
        <b-alert variant="success" :show="showSavedAlert">
            Les modifications ont bien été enregistrées
        </b-alert>
        <b-alert variant="danger" :show="showNotSavedAlert">
            {{ notSavedMessage }}
        </b-alert>
        <b-button
            variant="success"
            class="btn-success"
            title="Enregister"
            @click="legalDataSave"
        >
            <i class="fal fa-save fa-fw"></i
            ><span class="pl-2">Enregistrer</span>
        </b-button>
    </div>
</template>

<style scoped></style>
